import { filtersToApiParams } from "@/utils/filterUtils";

export const catalogArchivedFilterValue = (filters = {}) =>
  filters.searchValues?.show_archived ? "all" : "active";

/**
 * Собирает API-параметры фильтров каталога.
 * @param {Object} filters - Текущие фильтры страницы
 * @param {Array} searchFields - Конфиг поисковых полей
 * @returns {Object}
 */
export const catalogFiltersToApiParams = (
  filters,
  searchFields = []
) => {
  const params = filtersToApiParams(filters, searchFields);

  delete params["q[enabled]"];
  delete params["q[show_archived]"];
  params["q[archived]"] = catalogArchivedFilterValue(filters);

  return params;
};
